import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { callApi, formatDate, getInlineLoader, parseJson } from "../Helpers";
import { STR_NEW, STR_NO_RECORD, STR_NOTIFICATIONS } from "../Strings";

export default function View(props) {

	const appContext = useContext(AppContext);
	const [ready, setReady] = useState(false);

	async function init() {
		setReady(false);
		await appContext.getCurrentUserData();
		setReady(true);
	}

	function markAsRead(notificationId) {
		return new Promise(async resolve => {
			await callApi("mark-notification-as-read", {
				notificationId,
			}).then(async response => {
				if(response.status === 1) {
					await appContext.getCurrentUserData();
				}

				resolve(response);
			})
		})
	}

	async function openNotification(notification) {
		await markAsRead(notification.id);

		if (notification.navable) {
			appContext.navTo({
				item: notification.navItem,
				subItem: notification.navSubItem,
				extraItem: notification.navExtraItem,
				moreItem: notification.navMoreItem,
			})
		}
	}

	function isNew(notificationId) {
		const newNotifications = parseJson(
			appContext.currentUserData?.newNotifications,
			[]
		);
		return newNotifications.some((notification) => notification.id === notificationId);
	}

	useEffect(() => {
		init();
	}, [])

	if (ready) {
		const notifications = parseJson(
			appContext.currentUserData?.notifications,
			[]
		).reverse();

		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingBottom: "calc(var(--topBarHeight) + 40px)",
				}}
				className="mNoScrollBar"
			>
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<h6 className="mSectionTitle">
								{STR_NOTIFICATIONS[appContext.language]}
							</h6>
						</div>

						<div className="col-md-12">
							{
								(notifications.length > 0) ?
								notifications.map((item) => (
									<div key={item.id} className="col-12">
										<div
											className="card"
											onClick={() => openNotification(item)}
										>
											<div className="card-body">
												<h6
													style={{ fontSize: "12px" }}
													className="font-bold text-end text-muted"
												>
													{formatDate(item.date)}
												</h6>

												<h6 style={{ fontSize: "14px" }}>
													{item.message?.[appContext.language] || item.message || ""}
												</h6>

												{
													(isNew(item.id)) ?
													<h6
														style={{ fontSize: "12px" }}
														className="font-bold text-primary"
													>
														{STR_NEW[appContext.language]}
													</h6>
													:""
												}
											</div>
										</div>
									</div>
								))
								:
								<h6>{STR_NO_RECORD[appContext.language]}</h6>
							}
						</div>
					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{ width: "100%", height: "100%" }}
			>
				{getInlineLoader()}
			</div>
		);
	}
}
